import axios from "axios";

const addUserToTour = async (token, tourId, role, userId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}/users/${role}/${userId}`;

  try {
    const response = await axios.put(path, null, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default addUserToTour;